module.exports = __webpack_public_path__ + "static/media/horma-clasica-y-completa.83ec9737.png";